import { getGeoCountry } from "asos-site-chrome-store-presentation";

import euCountries from "@src/helpers/euCountries";
import {
  openCookieMessage,
  publishGeoCountry
} from "@template/state/modules/layout";

export const dispatchCookiesPolicy = store => {
  const geoCountry = getGeoCountry();
  const withCookiePolicy = geoCountry
    ? euCountries.includes(geoCountry.toUpperCase())
    : false;

  if (!withCookiePolicy) return;

  store.dispatch(publishGeoCountry(geoCountry));
  const cookiePolicy = JSON.parse(localStorage.getItem("cookie_policy"));
  if (cookiePolicy && !cookiePolicy.includes(geoCountry)) {
    store.dispatch(openCookieMessage());
  }

  if (!cookiePolicy) {
    store.dispatch(openCookieMessage());
  }
};
